const CONTACT_CONVERSION_SEND_TO = 'AW-18314926402/6w86CPqvu84cEMKynp1E'
const CONVERSION_REDIRECT_DELAY = 800

declare global {
   interface Window {
      gtag?: (...args: any[]) => void
   }
}

type TrackableEvent = {
   preventDefault?: () => void
}

export const trackContactConversion = (url: string, event?: TrackableEvent) => {
   event?.preventDefault?.()
   let hasRedirected = false

   const redirectToTarget = () => {
      if (hasRedirected) return
      hasRedirected = true
      window.location.href = url
   }

   if (typeof window.gtag !== 'function') {
      redirectToTarget()
      return false
   }

   window.gtag('event', 'conversion', {
      send_to: CONTACT_CONVERSION_SEND_TO,
      value: 1.0,
      currency: 'VND',
      event_callback: redirectToTarget
   })

   window.setTimeout(redirectToTarget, CONVERSION_REDIRECT_DELAY)

   return false
}
